module.exports = __webpack_public_path__ + "static/cozzolino.6414978b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/cozzolino.png
// module id = 665
// module chunks = 227585929013685